// parallax.js — Scroll-based depth layers

let deepEl, midEl;
let targetY = 0;
let currentY = 0;
let ticking = false;
let enabled = true;

function update() {
  ticking = false;
  // Lerp for smoothness
  currentY += (targetY - currentY) * 0.08;

  // As the section scrolls out, counteract at different rates so each layer
  // appears at a different depth. Lower factor = slower exit = appears deeper.
  if (deepEl) deepEl.style.transform = `translateY(${currentY * 0.55}px)`;
  if (midEl)  midEl.style.transform  = `translateY(${currentY * 0.28}px)`;

  if (Math.abs(targetY - currentY) > 0.1) {
    requestAnimationFrame(update);
    ticking = true;
  }
}

function onScroll() {
  if (!enabled) return;
  targetY = window.scrollY;
  if (!ticking) {
    ticking = true;
    requestAnimationFrame(update);
  }
}

export function initParallax() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  deepEl = document.querySelector('.parallax-deep');
  midEl  = document.querySelector('.parallax-mid');
  // Keep hero text anchored to layout (no parallax on foreground copy),
  // so subtitle/CTA don't "bounce" after scroll settles.
  const fgEl = document.querySelector('.parallax-fg');
  if (fgEl) fgEl.style.transform = 'none';

  window.addEventListener('scroll', onScroll, { passive: true });
}
